/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import { elementInViewport, getWindowSize, scrollTo } from '../../utils/dom.js';
import 'vue';
import 'raf';
import 'lodash/isString';
import '../../utils/easing.js';

function scrollToElm(elm) {
  var rect = elm.getBoundingClientRect();
  if (!elementInViewport(elm)) {
    var winHeight = getWindowSize().height;
    scrollTo(rect.top - (winHeight / 2 - rect.height / 2), {});
  }
}

export { scrollToElm as default };
//# sourceMappingURL=scrollToElm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/guide/utils/scrollToElm.js
// module id = null
// module chunks = 